/* eslint-disable consistent-return */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import {
  Col, Button, message, Row,
} from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { SET_VISIBLE_MODAL_PERIODO_FISCAL } from 'store/reducers/app/index';
import { store } from 'store';

const DEV = process.env.NODE_ENV === 'development';
const capitalizeFirstLetter = ([first, ...rest]) => [first.toUpperCase(), ...rest].join('');

const CloseButton = () => (
  <Button
    icon={<CloseCircleOutlined />}
    onClick={() => message.destroy()}
    type="link"
    style={{
      position: 'absolute',
      top: -30,
      right: -20,
    }}
  />
);

export const onError = (err, setLoading = null, formsInstances = [], setCurrentTabKey) => {
  if (typeof setLoading === 'function') setLoading(false);
  // eslint-disable-next-line no-console
  console.error(err);
  // API errors
  if (axios.isCancel(err)) return;
  if (err.response) {
    const { response } = err;
    if (response.status === 403) return;
    const { detail } = err.response.data;

    if (detail) {
      // response error is CFDI
      if (detail?.message?.includes('CFDI')) {
        return message.warn({
          content: (
            <Col style={{ width: 400 }}>
              <Row justify="center">
                <strong>ERROR INDICADO POR SAT</strong>
              </Row>
              <Row justify="center">
                {detail.message}
              </Row>
              <Row justify="center">
                <Button
                  onClick={() => {
                    window.open('https://agsc.siat.sat.gob.mx/PTSC/ValidaRFC/index.jsf', '_blank');
                  }}
                >
                  Para validar mas información presione aquí
                </Button>
              </Row>
              <CloseButton />
            </Col>
          ),
          duration: 30,
          style: {
            top: 30,
          },
        });
      }
      // Default detail(s)
      return message.warn(Array.isArray(detail) ? `${detail.join(', ').replace('.', '')}.` : detail);
    }
    if (err?.response?.data && typeof err?.response?.data === 'object'
        && err?.response?.headers['content-type'].includes('application/json')) {
      const keys = Object.keys(err.response.data);
      let normalized = keys.map((key) => {
        let errors = '';
        if (typeof response.data[key] === 'object') {
          errors = `${Object.values(response.data[key]).flat().join(', ').replace('.', '')}.`;
        } else if (Array.isArray(response.data[key])) {
          errors = `${response.data[key].join(', ').replace('.', '')}.`;
        } else if (typeof response.data[key] === 'string') {
          errors = response.data[key];
        }
        return ({
          key,
          displayName: capitalizeFirstLetter(key.replace(/_/g, ' ')),
          errors,
        });
      });
      normalized = normalized.filter((i) => i.errors.length);
      if (normalized.some((e) => e.key === 'periodo_fiscal' && /required/i.test(e.errors))) {
        store.dispatch({
          type: SET_VISIBLE_MODAL_PERIODO_FISCAL,
          payload: true,
        });
        return message.info('Seleccione un Periodo Fiscal e intentelo de nuevo', 5);
      }
      if (normalized.length) {
        return message.warn({
          content: (
            <Col>
              <strong>Solucione las siguientes advertencias</strong>
              <br />
              {normalized.map((item) => (
                <React.Fragment key={item.key}>
                  <p style={{ margin: 0, display: 'block', textAlign: 'left' }}>
                    <strong style={{ marginRight: 3 }}>
                      {item.displayName}
                      :
                    </strong>
                    {item.errors}
                  </p>
                </React.Fragment>
              ))}
              <CloseButton />
            </Col>
          ),
          duration: 30,
          style: {
            top: 30,
          },
        });
      }
    }
  }
  // Form errors
  if (err.errorFields) {
    const forms = formsInstances.map((f) => ({
      tabKey: f?.__INTERNAL__?.name,
      keys: f?.getFieldsError()?.map((e) => e.name[0]),
    }));
    const errorKeys = err.errorFields.map((e) => e.name[0]);
    const formWithErrors = forms.find((f) => f.keys.some((k) => errorKeys.includes(k)));
    if (formWithErrors) {
      setTimeout(() => {
        if (typeof setCurrentTabKey === 'function') {
          setCurrentTabKey(formWithErrors.tabKey);
        }
      });
    }
    return;
  }
  // Default message
  return message.warn(err.message && DEV ? err.message : 'Sucedió algo inesperado, intente mas tarde');
};

export const onSuccess = (res = {}, msg = 'Acción/Operación realizada correctamente', duration = 2.5) => {
  message.destroy();
  if (res?.data) return message.info(res.data.detail || msg, duration);
  return message.info(msg, duration);
};
